// filterSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {}
};

const filterSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setFilters: (state, action) => {
            // Completely replace the filters instead of merging
            state.filters = action.payload;
        },
        clearFilters: (state) => {
            state.filters = {};
        },
        removeFilter: (state, action) => {
            const { key, value } = action.payload;
            if (state.filters[key]) {
                state.filters[key] = state.filters[key].filter(v => v !== value);
                if (state.filters[key].length === 0) {
                    delete state.filters[key];
                }
            }
        }
    }
});

export const { setFilters, clearFilters, removeFilter } = filterSlice.actions;
export const selectFilters = (state) => state.filters.filters;
export default filterSlice.reducer;
